import { ForwardedRef, forwardRef } from "react";

// Custom styles for MDButton
import MDButtonRoot from "../MDButton/MDButtonRoot";

// Material Dashboard 2 PRO React contexts

import { BaseProps } from "@mui/material/OverridableComponent";
import { useMaterialUIController } from "../../../../Context";

export const MDButton = forwardRef(
  ({
    size = "medium",
    variant = "contained",
    color = "white",
    circular = false,
    iconOnly = false,
    children,
    ...rest
  }: BaseProps<any>, ref: ForwardedRef<any>) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller as any;

    return (
      <MDButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === "gradient" ? "contained" : variant}
        size={size}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode }}
      >
        {children}
      </MDButtonRoot>
    );
  }
);

// Setting default values for the props of MDButton
MDButton.defaultProps = {
  size: "medium",
  variant: "contained",
  color: "white",
  circular: false,
  iconOnly: false,
};